/** Типы пакетов для внутреннего использования на фронте */
export enum EInternalPackageType {
  /** Пакет (старый раздел, вкладка "Купить пакет" - не используется) */
  LegacyPackage = 'legacy_package',
  /** Пакет (новый раздел, вкладка "Купить пакет") */
  Package = 'package',
  /** AB-Подписка (Сводка) */
  Subscription = 'subscription',
  /** Продление AB-подписки (Сводка) */
  SubscriptionPublication = 'subscription_publication',
  /** Персональный пакет (новый раздел, вкладка "Персональные предложения") */
  PersonalPackage = 'personal_package',
  /** Персональная подписка на слоты (новый раздел, вкладка "Персональные предложения") */
  PersonalSubscription = 'personal_subscription',
  /** Персональная подписка на публикации (новый раздел, вкладка "Персональные предложения") */
  PersonalSubscriptionPublication = 'personal_subscription_publication',
  /** Смарт-пакет (новый раздел, вкладка "Персональные предложения") */
  SmartPackage = 'smart_package',
  /** Конструктор (новый и старый разделы, вкладка "Собрать свой пакет") */
  CustomPackage = 'custom_package',
}
